import { TournamentEntity } from 'app/interfaces/entity';
import { CurrentTournamentState } from 'modules/tournaments/store/current-tournament/interfaces';

export const setCurrentTournamentReducer = (
  state: CurrentTournamentState,
  action: { payload: TournamentEntity }
): void => {
  if (action.payload) {
    state.entity = action.payload;
  }
};

export const clearTournamentReducer = (state: CurrentTournamentState): void => {
  state.entity = {};
};
